<template>
  <div>
    <h3>{{ $t('employee.tabs.lastDayPay') }}</h3>
    <div class="last-day-pay__title">
      {{ $t('employee.lastDayPay.outstandingBalanceLabel') }}
      <span>{{ outstandingBalance }}</span>
    </div>
    <p>{{ $t(balanceHelpKey) }}</p>
    <p>{{ $t('employee.lastDayPay.readOnlyBalanceChangesHelp') }}</p>
  </div>
</template>

<script>
import State from '@/state/State';
import { toCurrency } from '@/utils';

const BALANCE_HELP_KEYS = {
  lip: 'employee.lastDayPay.readOnlyBalanceHelpLip',
  osv: 'employee.lastDayPay.readOnlyBalanceHelpOsv',
};

export default {
  name: 'EmployeeLastDayPayReadOnly',
  props: {
    balance: Object,
    currency: String,
  },
  computed: {
    outstandingBalance() {
      return toCurrency(+this.balance?.total_outstanding || 0, this.currency);
    },
    balanceHelpKey() {
      return (
        BALANCE_HELP_KEYS[State.state.company?.properties?.partnership] ||
        'employee.lastDayPay.readOnlyBalanceHelpStream'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.last-day-pay__title {
  margin-bottom: 12px;
  font-size: 1.1rem;
}
</style>
